export const GET_PROGRAMS_REQUESTED = 'GET_PROGRAMS_REQUESTED';
export const GET_PROGRAMS_SUCCESS = 'GET_PROGRAMS_SUCCESS';
export const GET_PROGRAMS_FAILED = 'GET_PROGRAMS_FAILED';

export const PROGRAM2_REQUESTED = 'PROGRAM2_REQUESTED';
export const PROGRAM2_SUCCESS = 'PROGRAM2_SUCCESS';
export const PROGRAM2_FAILED = 'PROGRAM2_FAILED';


export const PROGRAM1_REQUESTED = 'PROGRAM1_REQUESTED';
export const PROGRAM1_SUCCESS = 'PROGRAM1_SUCCESS';
export const PROGRAM1_FAILED = 'PROGRAM1_FAILED';